import styled from 'styled-components';
import { dimensions, colors, typography } from 'modules/common/styles';
import { BoxRoot } from 'modules/common/styles/main';

const rowTitleSize = 230;
const boxSize = 150;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: ${dimensions.coreSpacing}px;
  // height: 500px;

  .calls {
    text-align: center;
    margin: auto;
  }

  .customTabs .nav-tabs {
    margin-bottom: 1.5rem;
    border: none;
  }
  .customTabs .nav-tabs > li > a {
    font-weight: 600;
    color: #373737;
    // border-bottom: 2px solid #DDD;
    margin: 0px;
    border-left: none;
    padding: 10px 50px;
    border-top: none;
    border-right: none;
  }
  .customTabs .nav-tabs > li.active > a {
    border-bottom: 2px solid #4d528e;
    border-left: none;
    border-top: none;
    border-right: none;
    border-bottom-color: #4d528e;
    color: #4d528e;
    background: none;
  }
  .customTabs .nav-tabs > li > a:focus {
    outline: none;
  }
  .fileI {
    height: 211px;
    width: 100%;
    margin: 15px 0 auto;
    position: relative;
    text-align: center;
    line-height: 195px;
    border: 1px dashed #dae0e6;
    display: inline-block;
    transition: transform 0.3s;
    background: #faf8ff;
    letter-spacing: 0.23px;
    color: #5b5b5b;
  }
  .fileI img {
    display: block;
    margin-left: 150px;
    margin-top: 53px;
    margin-bottom: -70px;
  }
  input[type='file'] {
    position: absolute;
    height: 100%;
    width: 100%;
    opacity: 0;
    top: 0;
    left: 0;
    cursor: pointer;
  }

  .FModal {
    background: #000;
  }
`;

const RowTitle = styled.h3`
  font-size: ${typography.fontSizeHeading7}px;
  font-weight: ${typography.fontWeightMedium};
  padding: 0 ${dimensions.coreSpacing * 2}px;
  text-transform: uppercase;
  margin: ${dimensions.coreSpacing}px 0;
  color: ${colors.colorCoreDarkGray};
  flex-shrink: 0;
  // width: ${rowTitleSize}px;

  
`;

const Box = BoxRoot.extend`
  width: ${boxSize}px;
  height: ${boxSize}px;
`;

const Divider = styled.div`
  border-bottom: 1px dotted ${colors.borderDarker};
  padding-bottom: ${dimensions.coreSpacing}px;
  margin-bottom: ${dimensions.coreSpacing}px;
  margin-left: ${rowTitleSize}px;
`;

const BoxName = styled.span`
  font-size: ${typography.fontSizeUppercase}px;
`;

const DataWrapperClass = styled.div`
  section.sc-feJyhm.cHLQhJ {
    background: #fff;
    overflow: hidden;
  }
  .sc-cmTdod.cpKXNr {
    overflow: hidden;
    background: #fff;
  }
  section.sc-jtRfpW.daxgFZ {
    margin-right: 20px;
  }
  section.sc-iELTvK.dstvIj {
    background: #fff;
    margin-left: 20px;
  }
`;

const DataBox = styled.div`
  // box-shadow: 0px 3px 6px #00000029;
  // border-radius: 5px;
  // padding: 15px;
  margin-top: 15px;
  margin-bottom: 20px;

  margin: auto;

  //  &:hover {
  //     box-shadow: 0px 3px 6px #00000029;
  //  }

  .custom_radio input[type='radio'] {
    display: none;
  }
  .custom_radio input[type='radio'] + label {
    position: relative;
    display: inline-block;
    padding-left: 2.5em;
    padding-top: 11px;
    cursor: pointer;
    line-height: 1em;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    width: 150px;
    height: 60px;
  }
  .custom_radio input[type='radio']:checked + label {
    box-shadow: 0px 10px 24px #004eff17;
    border-radius: 13px 14px 87px 35px;
  }
  .custom_radio input[type='radio'] + label:before,
  .custom_radio input[type='radio'] + label:after {
    content: '';
    position: absolute;
    top: 23px;
    left: 10px;
    width: 1em;
    height: 1em;
    text-align: center;
    color: white;
    font-family: Times;
    border-radius: 50%;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .custom_radio input[type='radio'] + label:before {
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    box-shadow: inset 0 0 0 0.2em white, inset 0 0 0 1em white;
  }
  .custom_radio input[type='radio'] + label:before {
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    box-shadow: inset 0 0 0 0.3em white, inset 0 0 0 1em #c6c6c6;
  }
  .custom_radio input[type='radio']:checked + label:before {
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    box-shadow: inset 0 0 0 0.2em white, inset 0 0 0 1em #4caf50;
    background-image: url('/images/check.png');
  }

  .lines1 {
    width: 100px;
    height: 9px;
    background: #bbc0c6;
    border-radius: 5px;
    opacity: 0.91;
  }
  .lines2 {
    width: 72px;
    height: 9px;
    background: #bbc0c6;
    border-radius: 5px;
    opacity: 0.8;
    margin-top: 5px;
  }
  .lines3 {
    width: 46px;
    height: 9px;
    background: #e4e4e4;
    border-radius: 5px;
    opacity: 1;
    margin-top: 5px;
  }

  label.sc-fAjcbJ.eEqIoJ {
    margin-bottom: 0px;
  }
  .extraSpace {
    margin-left: 25px;
  }
  .sc-bRBYWo.lkwzdZ {
    margin-bottom: 0px;
  }
`;

const FileWrapper = styled.div`
  position: relative;
  padding-left: 40px;
  padding-right: 20px;
  min-width: 120px;
  min-height: 36px;
  line-height: 36px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;

  i {
    font-size: 26px;
    position: absolute;
    left: 10px;
    top: 0;
  }

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    direction: rtl;
    text-align: left;
    max-width: 200px;
    display: block;
  }
`;

const Avatar = styled.div`
  img {
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 50px;
  }
`;

const ModalClass = styled.div``;

export {
  Row,
  RowTitle,
  Box,
  Divider,
  BoxName,
  DataWrapperClass,
  DataBox,
  FileWrapper,
  Avatar,
  ModalClass
};



// WEBPACK FOOTER //
// src/modules/screens/settings/PhoneCalls/styles.js